import { useTheme } from '@mui/material';

export const useAvatarCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      display: 'flex',
    },
    text: {
      marginTop: 'auto',
      marginBottom: 'auto',
      paddingLeft: theme.spacing(),
    },
  };
};
